import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { focusManager } from "@tanstack/react-query";

export const APP_RESUMED_EVENT = "athletain:app-resumed";

// When the phone backgrounds the app, iOS tears its sockets down without
// telling the WebView. On return: mark the app focused so React Query refetches
// whatever is stale, and announce the resume so long-lived connections (the
// notification stream) reconnect now instead of after their backoff.
// Call once, at startup.
export const startAppLifecycle = () => {
  const announceResume = () => window.dispatchEvent(new Event(APP_RESUMED_EVENT));

  if (Capacitor.isNativePlatform()) {
    App.addListener("pause", () => focusManager.setFocused(false));
    App.addListener("resume", () => {
      focusManager.setFocused(true);
      announceResume();
    });
    return;
  }

  // Web: React Query already follows visibilitychange for focus.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") announceResume();
  });
};
